export default __webpack_public_path__ + "static/media/phil2.a7dacd3e.jpg";